import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

/** Left-aligned text button for a list of choices; the selected one is brand-colored and shaded. */
export const OptionButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'selected',
})<{ selected: boolean }>(({ theme, selected }) => ({
  justifyContent: 'flex-start',
  borderRadius: theme.shape.borderRadius,
  color: selected ? theme.palette.primary.main : theme.palette.text.primary,
  backgroundColor: selected ? theme.palette.action.selected : 'transparent',
  fontWeight: selected ? theme.typography.fontWeightSemiBold : theme.typography.fontWeightRegular,
}));
